export default __webpack_public_path__ + "static/media/pilz-11.87a7f1d7.png";